import { css } from 'styled-components';

// Vertical (left/right) tabs styled as a card with pill-style active item.
// Scoped to side positions so top-tab usages keep antd's default look.
export const sideTabsStyles = css`
  &.ant-tabs-left .ant-tabs-nav-list,
  &.ant-tabs-right .ant-tabs-nav-list {
    background: ${({ theme }) => theme?.colors?.surface || '#ffffff'};
    border-radius: 12px;
    padding: 14px;
    flex: 0 0 auto;
  }

  /* remove antd's divider line and ink bar for side tabs */
  &.ant-tabs-left > .ant-tabs-nav::before,
  &.ant-tabs-right > .ant-tabs-nav::before,
  &.ant-tabs-left .ant-tabs-ink-bar,
  &.ant-tabs-right .ant-tabs-ink-bar {
    display: none;
  }

  &.ant-tabs-left .ant-tabs-tab,
  &.ant-tabs-right .ant-tabs-tab {
    margin: 0 !important;
    padding: 10px 14px !important;
    border-radius: 8px !important;
    border: none;
    background: transparent;
    justify-content: flex-start;
    transition: background 0.15s ease;
  }

  &.ant-tabs-left .ant-tabs-tab + .ant-tabs-tab,
  &.ant-tabs-right .ant-tabs-tab + .ant-tabs-tab {
    margin-top: 4px !important;
  }

  &.ant-tabs-left .ant-tabs-tab .ant-tabs-tab-btn,
  &.ant-tabs-right .ant-tabs-tab .ant-tabs-tab-btn {
    color: ${({ theme }) => theme?.colors?.textSecondary || '#64748b'};
    font-weight: 400;
  }

  &.ant-tabs-left .ant-tabs-tab:hover,
  &.ant-tabs-right .ant-tabs-tab:hover {
    background: ${({ theme }) => theme?.colors?.primaryLighter || '#f4f5ff'};
  }

  &.ant-tabs-left .ant-tabs-tab-active,
  &.ant-tabs-right .ant-tabs-tab-active {
    background: ${({ theme }) => theme?.colors?.primaryLight || '#e8e9ff'};
  }

  &.ant-tabs-left .ant-tabs-tab-active .ant-tabs-tab-btn,
  &.ant-tabs-right .ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${({ theme }) => theme?.colors?.primary || '#5c67f7'} !important;
  }

  &.ant-tabs-left .ant-tabs-content-holder,
  &.ant-tabs-right .ant-tabs-content-holder {
    border: none;
  }
`;
